// Pre-written moderation reasons so admins can pick instead of retyping. Each
// is shown verbatim to the vendor (rejection) or kept internal (suspension).
export const REJECTION_REASONS = [
  'Invalid documents',
  'Missing information',
  'Document and business name mismatch',
  'Blurry or unreadable documents',
  'PAN/VAT could not be verified',
  'Duplicate vendor account',
];

export const SUSPENSION_REASONS = [
  'Policy violation',
  'Customer complaints / poor ratings',
  'Counterfeit or prohibited products',
  'Payment / payout dispute',
  'Suspected fraudulent activity',
];
